/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import {
  Link,
  useParams,
} from 'react-router-dom'

import { useFragment } from 'react-relay'

import { Button } from '@pareto-engineering/design-system'

import { useBlog } from '../Context'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'category-button'

const CATEGORY_FRAGMENT = graphql`
  fragment CategoryButtonFragment on BlogCategoryNode {
    slug
    name
  }
`

/**
 * This is the component description.
 */
const CategoryButton = ({
  id,
  className:userClassName,
  style,
  node,
  color,
  activeColor,
  // ...otherProps
}) => {
  const { category } = useParams()

  const fragment = useFragment(
    CATEGORY_FRAGMENT,
    node,
  )

  const {
    name,
    slug,
  } = fragment

  const onCurrentCategory = category === slug

  const {
    generateBlogPath,
  } = useBlog()

  const url = !onCurrentCategory ? generateBlogPath(
    'LIST_CATEGORY',
    {
      category:slug,
    },
  ) : generateBlogPath(
    'LIST',
  )

  return (
    <Link
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
      // {...otherProps}
      to={url}
    >
      <Button
        color={onCurrentCategory ? activeColor : color}
        isCompact
      >
        {name}
      </Button>
    </Link>
  )
}

CategoryButton.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The category node ref
   */
  node:PropTypes.node.isRequired,

  /**
   * The color of the button
   */
  color:PropTypes.string,

  /**
   * The color of the button when active
   */
  activeColor:PropTypes.string,
}

CategoryButton.defaultProps = {
  activeColor:'interactive',
  color      :'background-near',
}

CategoryButton.Group = Button.Group

export default CategoryButton
